// How a garment is described at checkout: Brand, Color and Fabric.
//
// A copy of fxrybackend/helper/itemDescription.js (the apps share no code) —
// keep fxryshop, fxrypopup and the backend the same.
//
// The three are saved on the item as brand / no_label / color / fabric, and
// also joined into `description`, which receipts, invoices, exports, HubSpot
// and the old admin all read.

export const NO_LABEL_TEXT = "No label";

/** "Babaa · Cream · Chunky cotton knit". Blank parts are left out. */
export const describeItem = ({ brand, no_label, color, fabric } = {}) =>
  [no_label ? NO_LABEL_TEXT : brand, color, fabric]
    .map((part) => String(part ?? "").trim())
    .filter(Boolean)
    .join(" · ");

/** Brand (or No label) and Color are required; Fabric is optional. */
export const itemDescriptionComplete = ({ brand, no_label, color } = {}) =>
  Boolean(String(color ?? "").trim()) &&
  (Boolean(no_label) || Boolean(String(brand ?? "").trim()));
